import React from 'react';
import { motion } from 'framer-motion';

export default function Button({ children, onClick, className = '', fullWidth = false }) {
  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className={`
        bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-4 px-8 rounded-lg shadow-lg 
        transition-colors duration-200 flex items-center justify-center text-lg sm:text-xl
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
    >
      {children}
    </motion.button>
  );
}